import { ASSETS, LINKS } from "@/lib/brand";
import { Instagram, Linkedin, ShoppingBag, Calendar } from "lucide-react";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-charcoal text-ivory">
      <div className="container-edit py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="font-serif-heading text-3xl md:text-4xl italic">Stefanie Winstan</div>
            <p className="mt-4 text-ivory/70 text-sm max-w-sm">
              Realtor · Creator · Model · Actor. CFO of Primo Group, serving
              Ottawa &amp; surrounding areas.
            </p>
            <div className="mt-8 flex items-center gap-5">
              <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="text-ivory/80 hover:text-bronze transition-colors">
                <Instagram size={18} strokeWidth={1.4} />
              </a>
              <a href={LINKS.linkedin} target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin" className="text-ivory/80 hover:text-bronze transition-colors">
                <Linkedin size={18} strokeWidth={1.4} />
              </a>
              <a href={LINKS.amazon} target="_blank" rel="noopener noreferrer" data-testid="footer-amazon" className="text-ivory/80 hover:text-bronze transition-colors">
                <ShoppingBag size={18} strokeWidth={1.4} />
              </a>
              <a href={LINKS.calendly} target="_blank" rel="noopener noreferrer" data-testid="footer-calendly" className="text-ivory/80 hover:text-bronze transition-colors">
                <Calendar size={18} strokeWidth={1.4} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="overline !text-bronze">Real Estate</div>
            <ul className="mt-4 space-y-3 text-sm text-ivory/85">
              <li><a className="hover:text-bronze" data-testid="footer-site-link" href={LINKS.website} target="_blank" rel="noopener noreferrer">thepgsells.com</a></li>
              <li><a className="hover:text-bronze" data-testid="footer-home-value-link" href={ASSETS.homeValueUrl} target="_blank" rel="noopener noreferrer">What&apos;s Your Home Worth?</a></li>
              <li><a className="hover:text-bronze" href="#real-estate">About Primo Group</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline !text-bronze">Talent</div>
            <ul className="mt-4 space-y-3 text-sm text-ivory/85">
              <li><a className="hover:text-bronze" target="_blank" rel="noopener noreferrer" href={LINKS.backstageUGC}>UGC</a></li>
              <li><a className="hover:text-bronze" target="_blank" rel="noopener noreferrer" href={LINKS.backstageModel}>Modeling</a></li>
              <li><a className="hover:text-bronze" target="_blank" rel="noopener noreferrer" href={LINKS.calendly}>Book a Call</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="overline !text-bronze">Contact</div>
            <ul className="mt-4 space-y-3 text-sm text-ivory/85">
              <li><a className="hover:text-bronze" href="mailto:stef@stefwinstan.com">stef@stefwinstan.com</a></li>
              <li><a className="hover:text-bronze" href="#contact">Send Message</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-ivory/10 flex flex-wrap items-center justify-between gap-4">
          <div className="flex items-center gap-4">
            <img src={ASSETS.primoLogo} alt="Primo Group logo" className="h-10 w-auto brightness-110" data-testid="footer-primo-logo" />
            <span className="text-[10px] uppercase tracking-[0.22em] text-ivory/50">Powered by Valery Real Estate Inc., Brokerage</span>
          </div>
          <p className="text-[11px] text-ivory/40">© {year} Stefanie Winstan. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
